module.exports = __webpack_public_path__ + "static/img/2.d9c4762.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/2/zh/2.png
// module id = tR7H
// module chunks = 0